import { SoftwareEscrowRequestChangesRoutesEnum } from '../model';

export const getRequestChangesExitPath = (escrowId: string, route: `${SoftwareEscrowRequestChangesRoutesEnum}`) => {
  if (route === SoftwareEscrowRequestChangesRoutesEnum.Deposits) return `/software-escrows/${escrowId}/deposits`;

  return `/software-escrows/${escrowId}/settings/${route}`;
};
